require('./dist/angular-validation-match');
module.exports = 'validation.match';



//////////////////
// WEBPACK FOOTER
// ./~/angular-validation-match/index.js
// module id = 706
// module chunks = 0